import React, { HTMLAttributes, PureComponent } from 'react';
import { Button } from 'antd';
import './ClearButton.css';

export class ClearButton extends PureComponent<HTMLAttributes<HTMLDivElement>> {
    render() {
        const { onClick, ...otherProps } = this.props;
        return (
            <div className="clear-button-wrapper" {...otherProps}>
                <div className="clear-button">
                    <Button onClick={onClick}>
                        CLEAR
                        <br />
                        ALL
                    </Button>
                </div>
            </div>
        );
    }
}
